import { Controller } from "@hotwired/stimulus";

// Orchestrates frame B: the PinPad fills, we submit; the server answers a
// failed attempt with a dispatched "sign-in:failed" event (turbo_power),
// and we play the wrong-PIN motion + message.
export default class extends Controller {
  static targets = ["form", "notice"];
  static values = { wrongPin: String };
  static outlets = ["pin-pad"];

  submit() {
    if (this.hasNoticeTarget) this.noticeTarget.classList.add("hidden");
    this.formTarget.requestSubmit();
  }

  failed(event) {
    if (this.hasPinPadOutlet) this.pinPadOutlet.wrong();
    if (!this.hasNoticeTarget) return;
    this.noticeTarget.textContent = event.detail?.message || this.wrongPinValue;
    this.noticeTarget.classList.remove("hidden");
  }
}
